module.exports = __webpack_public_path__ + "img/P150T_weapon_19.bbff9123.png";